export const QUERY_KEY = {
  PREFS: "PREFS",
  JOBS_OFFER: "JOBS_OFFER",
  JOBS: "JOBS",
  MAP_JOBS: "MAP_JOBS",
  SCROLL_POSITION_MAP: "SCROLL_POSITION_MAP",
  JOB_DETAIL: "JOB_DETAIL",
  MST_CONFIG: "MST_CONFIG",
  PROFILE: "PROFILE",
  INTERVIEW: "INTERVIEW",
  NEWS: "NEWS",
  NEWS_DETAIL: "NEWS_DETAIL",
  CHECK_STAFF: "CHECK_STAFF",
  MESSAGE: "MESSAGE",
  MESSAGE_DETAIL: "MESSAGE_DETAIL",
  STAFF_DETAIL: "STAFF_DETAIL",
  JOBS_APPLY: "JOBS_APPLY",
  JOBS_APPLY_DETAIL: "JOBS_APPLY_DETAIL",
  JOBS_PLAN: "JOBS_PLAN",
  JOBS_PLAN_DETAIL: "JOBS_PLAN_DETAIL",
  JOBS_WORK: "JOBS_WORK",
  JOBS_WORK_DETAIL: "JOBS_WORK_DETAIL",
  JOBS_RESULT_SALARY: "JOBS_RESULT_SALARY",
  JOBS_RESULT_SALARY_DETAIL: "JOBS_RESULT_SALARY_DETAIL",
  JOBS_RESULT_EMPLOYMENT: "JOBS_RESULT_EMPLOYMENT",
  JOBS_CONTRACT: "JOBS_CONTRACT",
  JOBS_WORK_END_REPORT: "JOBS_WORK_END_REPORT",
  SUMAJOB_STAFF: "SUMAJOB_STAFF",
  LIST_STAFF_MYNO: "LIST_STAFF_MYNO",
  LIST_IMAGE: "LIST_IMAGE",
  BANNER_HOME: "BANNER_HOME",
  BANNER_JOBS: "BANNER_JOBS",
  SALARY: "SALARY",
  WISH_LIST: "WISH_LIST",
  CONDITIONS: "CONDITIONS",
  FQA: "FQA",
  SETTINGS: "SETTINGS",
  BUSINESSES: "BUSINESSES",
  TOTAL_SEARCH_JOBS: "TOTAL_SEARCH_JOBS",
  EXPERIENCE_CONFIG: "EXPERIENCE_CONFIG",
  EXPERIENCES: "EXPERIENCES",
  STAFF_NOTIFICATION: "STAFF_NOTIFICATION",
  STAFF_POINTS: "STAFF_POINTS",
  SHIFT_STAFF_POINTS: "SHIFT_STAFF_POINTS",
  SHIFT_STAFF_POINT: "SHIFT_STAFF_POINT",
  REDEEMABLE_REWARD: "REDEEMABLE_REWARD",
  POINT_EXCHANGE_HISTORY: "POINT_EXCHANGE_HISTORY",
};
